import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./slices/Login";
import executiveLoginReudcer from "../Admin-Dashboard/store/slices/Login";
import NotificationReducer from "./slices/Notification";
import duplicationReducer from "./slices/Duplication";
import auditLogReducer from "./slices/auditLog";
import sideBarAccessReducer from "./slices/sideBarAccess";
import schedulerReducer from "./slices/Scheduler";

export const store = configureStore({
  reducer: {
    login: loginReducer,
    executiveLoginReudcer: executiveLoginReudcer,
    notification: NotificationReducer,
    duplication: duplicationReducer,
    auditLog: auditLogReducer,
    sideBarAccess: sideBarAccessReducer,
    scheduler: schedulerReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
